window.addEventListener('DOMContentLoaded', function() {
  $(document).on('click', '*[data-dismiss=flash]', function (event) {
    $(event.target).closest('.flash').remove();
  });
});
